<template>
  <div v-cloak  v-loading.fullscreen.lock="dataLoading"
       element-loading-text="Loading, please wait..."
       element-loading-spinner="el-icon-loading"
       element-loading-background="rgba(0, 0, 0, 0.8)">

    <el-dialog
      title="Modify Instance Tag"
      :visible.sync="editDialogVisible"
      :close-on-click-modal="false"
      :center="true"
      @opened="opened"
      width="500px"
      size="small">

      <el-form
        label-position="right"
        label-width="120px"
      >
        <el-form-item label="Tag: "  required>
          <el-input v-model="copyEditInstanceTagDO.tagName" size="small" ></el-input>
        </el-form-item>
        <el-form-item label="Description: " >
          <el-input v-model="copyEditInstanceTagDO.description" size="small" ></el-input>
        </el-form-item>

      </el-form>

      <span slot="footer" class="dialog-footer">
              <el-button type="success" @click="save">Save</el-button>
              <el-button @click="editDialogVisible = false">close</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
  import util from '@/util/util.js'

  export default {
    components: {

    },
    props:  {
      editInstanceTagDO: {
        type: Object,
        required: true,
        default:() => {}
      }
   },
    data(){
      return{
        editDialogVisible: false,
        dataLoading: false,
        copyEditInstanceTagDO:{}
      }
    },
    computed: {
    },
    created(){
    },


    methods: {
      opened(){
        this.copyEditInstanceTagDO = util.deepClone(this.editInstanceTagDO);
      },
      showDialog(){
        this.editDialogVisible = true;

      },
      hideDialog(){
        this.editDialogVisible = false;
      },
      save(){

        let url = this.baseAcsUrl + '/acs/data-instance-tag/update';

        if(!this.copyEditInstanceTagDO.tagName){
          this.$message.warning("tagName can't be empty");
          return;
        }
        this.dataLoading = true;
        this.http.put(url,this.copyEditInstanceTagDO).then(resp =>{
          this.$message.success('Successful operation ');
          this.editDialogVisible = false;
          this.dataLoading = false;
          this.$emit("saveSuccess");
        }).catch(error => {
          this.dataLoading = false;
          console.info(error);
          this.$emit("saveFail");
        });
      }
    }
  }

</script>

<style lang="scss" scoped>
  [v-cloak] {
    display: none;
  }
  .breadcrumb{
    background-color: transparent !important;
    margin-bottom: 0px;
  }
  .title{
    margin-left: 16px;
    font-size: 20px;
  }
 .el-form-item /deep/ .el-select{
   display: inline-block;
   width: 86%;
  }
  .add-banner-group  /deep/ .el-form-item__label{
    width: 148px !important;
  }
  .add-banner-group /deep/ .el-form-item__content{
    margin-left: 148px!important;
  }
</style>



// WEBPACK FOOTER //
// src/view/acs/tag/dialog/edit_instance_tag.vue